<template>
  <page>
    <v-card>
      <v-card-title>
        <v-flex xs4>
          <div class="headline">{{ this.labels.listTitle }}</div>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex xs4>
          <v-text-field append-icon="mdi-magnify" label="History Lookup" single-line hide-details v-model="filters.nricPassport" @input="init(filters.nricPassport)" clearable></v-text-field>
        </v-flex>
      </v-card-title>
      <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
          <span slot="activator">
            {{ props.header.text }}
          </span>
          <span>
            {{ props.header.text }}
          </span>
        </v-tooltip>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.nricPassport }}</td>
          <td class="text-xs-left">{{ props.item.reason }}</td>
          <td class="text-xs-left">{{ formatDate(props.item.startDate) }}</td>
          <td class="text-xs-left">{{ formatDate(props.item.endDate) }}</td>
          <td class="text-xs-left">{{ formatBoolean(props.item.active) }}</td>
          <td class="text-xs-right">
            <table-action :rowData="props" :remove="canRemove(props.item)" @remove="doPromptRemove(props.item)"></table-action>
          </td>
        </template>
      </v-data-table>
      <v-btn color="primary" dark class="mb-2" @click="doNew">New Insured Blacklist<v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-card>
    <v-dialog v-model="propUpDialog" max-width="600px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{ labels.formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <message :messages="messages"></message>
          <form>
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs12 v-if="newInsured">
                  <v-text-field v-model="insuredForm.nricPassport" :label="labels.nricPassport" :error-messages="errors.collect('nricPassport')" data-vv-name="nricPassport" :data-vv-as="labels.nricPassport" v-validate="'required|param|max:20'"></v-text-field>
                </v-flex>
                <v-flex xs12 v-else>
                  <v-subheader class="queryLabel">{{labels.nricPassport}}</v-subheader>
                  <div class="title">{{insuredForm.nricPassport}}</div>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-model="insuredForm.reason" :label="labels.reason" :error-messages="errors.collect('reason')" data-vv-name="reason" :data-vv-as="labels.reason" v-validate="'required|entry|max:100'"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click.native="doClose">Cancel</v-btn>
          <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Insured Blacklist? ({{deleteInsured}})
    </confirm>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
export default {
  data() {
    return {
      headers: [
        { text: 'Nric No. / Passport', value: 'nricPassport' },
        { text: 'Reason', value: 'reason' },
        { text: 'Start Date', value: 'startDate' },
        { text: 'End Date', value: 'endDate' },
        { text: 'Active', value: 'active' },
        TableConst.tableActionHeader
      ],
      labels: {
        listTitle: 'Insured Blacklist listing',
        formTitle: 'Insured Blacklist Details',
        nricPassport: 'NRIC No. / Passport*',
        startDate: 'Start Date*',
        endDate: 'End Date',
        active: 'Active',
        reason: 'Reason'
      },
      insuredForm: {
        nricPassport: undefined,
        startDate: null,
        endDate: null,
        active: null,
        reason: null
      },
      filters: {
        nricPassport: null,
        startDate: null,
        endDate: null,
        active: null
      },
      propUpDialog: null,
      newInsured: null,
      sumbitting: undefined,
      promptRemove: false,
      selectedInsured: undefined,
      deleteInsured: ''
    }
  },
  watch: {
    'filters.nricPassport': function(value) {
      if (typeof value === 'undefined') {
        this.init(null)
        this.labels.listTitle = 'Insured Blacklist Listing'
      } else if (value === null) {
        this.init(null)
        this.labels.listTitle = 'Insured Blacklist Listing'
      } else if (value === '') {
        this.init(null)
        this.labels.listTitle = 'Insured Blacklist Listing'
      } else {
        this.init(value)
        this.labels.listTitle = 'Blacklist History'
      }
    }
  },
  computed: {
    userMenu() {
      return this.$store.state.adminMember.menu
    }
  },
  methods: {
    async init(xnricPassport) {
      if (typeof xnricPassport !== 'undefined') {
        this.labels.listTitle = 'Insured Blacklist listing'
      } else if (xnricPassport === null) {
        this.labels.listTitle = 'Insured Blacklist listing'
      } else if (xnricPassport === '') {
        this.labels.listTitle = 'Blacklist History'
      } else {
        this.labels.listTitle = 'Insured Blacklist listing'
      }
      this.loading = true
      const apiURI = this.userMenu.getInsuredBlacklists
      const expand = {
        nricPassport: xnricPassport
      }
      if (apiURI) {
        try {
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((insuredBlackList) => {
              const convertList = {
                nricPassport: insuredBlackList.nricPassport,
                startDate: insuredBlackList.startDate,
                endDate: insuredBlackList.endDate,
                active: insuredBlackList.active,
                reason: insuredBlackList.reason
              }
              this.items.push(convertList)
            })
            this.loading = false
          } else {
            this.items = []
            this.loading = false
          }
        } catch (error) {
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL - Insured Blacklist')
        this.loading = false
      }
    },
    async doInit() {
      this.init(null)
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedInsured = data
        this.deleteInsured = data.nricPassport
      }
    },
    async doRemove() {
      const apiURI = this.userMenu.updateInsuredBlacklist
      if (apiURI) {
        this.loading = true
        const formatForm = {
          nricPassport: this.selectedInsured.nricPassport,
          startDate: this.selectedInsured.startDate,
          endDate: new Date(),
          reason: this.selectedInsured.reason,
          active: false
        }
        try {
          const result = await this.$http.put(apiURI, formatForm)
          this.notify(result.data)
          this.init()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    canRemove(data) {
      if (data.active) {
        return true
      } else {
        return false
      }
    },
    doNew() {
      this.resetValidator()
      this.resetMessages()
      this.insuredForm.startDate = new Date()
      this.insuredForm.active = true
      this.newInsured = true
      this.propUpDialog = true
    },
    doClose() {
      this.newInsured = false
      this.propUpDialog = false
      this.insuredForm.nricPassport = null
      this.insuredForm.startDate = null
      this.insuredForm.endDate = null
      this.insuredForm.reason = null
      this.insuredForm.active = false
      this.resetValidator()
      this.resetMessages()
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newInsured) {
            this.doCreate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.userMenu.createInsuredBlacklist
      if (apiURI) {
        this.sumbitting = true
        try {
          const result = await this.$http.post(apiURI, this.insuredForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.doClose()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    }
  },
  mounted() {
    this.doInit()
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>
</style>
